import Lightbox from "./PdfSdk/PdfLightBox";
import InLine from "./PdfSdk/PdfSDKViewer";

export default function PdfViewer(props) {
  const { file, filename, url } = props;
  console.log("PdfViewer", file, filename, url);
  return <InLine url={url} file={file} filename={filename} />;
}
